export function navigateToLogin(from: ReturnType<typeof useRoute>) {
  return navigateTo({
    name: 'login',
    query: {
      redirectTo: encodeURIComponent(from.fullPath),
    },
  })
}
